// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"629f977e","453":"23cb2979"}[chunkId] + ".chunk.js";
};